module.exports = __webpack_public_path__ + "static/media/change_icon_on.e52cd5e9.svg";